import { Extension } from '@tiptap/core';
import LegacyListConverter from './LegacyListConverter.js';
import LegacyHighlightConverter from './LegacyHighlightConverter.js';
import { changedDescendants } from '../utils.js';

const convertToFbc = (state, replaceFunction, oldDocument) => {
  const changedNodes = [];
  if (oldDocument) {
    changedDescendants(oldDocument, state.doc, 0, (node, pos) => {
      changedNodes.push({
        node,
        pos
      });
    });
  }
  const replacements = [];
  const transaction = state.tr;
  if (oldDocument) {
    changedNodes.forEach(({ node, pos }) => {
      const replacedChild = replaceFunction(node, state);
      if (replacedChild && replacedChild !== node) {
        replacements.push({
          type: "replacement",
          pos,
          original: node,
          replacement: replacedChild
        });
      }
    });
  } else {
    state.doc.forEach((node, pos) => {
      const replacedChild = replaceFunction(node, state);
      if (replacedChild && replacedChild !== node) {
        replacements.push({
          type: "replacement",
          pos,
          original: node,
          replacement: replacedChild
        });
      }
    });
  }
  const sortedReplacements = replacements.sort((a, b) => a.pos - b.pos);
  for (let i = sortedReplacements.length - 1; i >= 0; i--) {
    const { pos, original, replacement } = sortedReplacements[i];
    transaction.replaceWith(pos, pos + original.nodeSize, replacement);
  }
  if (transaction.docChanged) {
    transaction.setMeta("addToHistory", false);
    transaction.setMeta("$convertToFbc", true);
    return transaction;
  }
  return null;
};
const LegacyConverters = Extension.create({
  name: "legacyConverters",
  addExtensions() {
    return [
      LegacyListConverter,
      LegacyHighlightConverter
    ];
  }
});

export { convertToFbc, LegacyConverters as default };
//# sourceMappingURL=LegacyConverters.js.map
